"use client";

import { useFeatureFlags } from "@/hooks/useFeatureFlags";

export const NAVIGATION_UPDATES_FLAG = "sidebar-enable-navigation-updates-ff-319";

export const useNavigationUpdatesEnabled = (): boolean => Boolean(useFeatureFlags()[NAVIGATION_UPDATES_FLAG]);
